import React, { useEffect, useState } from "react";

import Button from "../components/button";
import Checkbox from "../components/checkbox";
import { InfoText, Link, RowContainer } from "../components/description";
import Dropdown from "../components/dropdown";
import Error from "../components/error";
import Footer from "../components/footer";
import Label from "../components/label";

function Personal({ type, goToNextStep, setFieldValue, isSubmitInProgress, ...props }) {
	const MonthList = [
		{ label: "Jan", value: "01" },
		{ label: "Feb", value: "02" },
		{ label: "Mar", value: "03" },
		{ label: "Apr", value: "04" },
		{ label: "May", value: "05" },
		{ label: "Jun", value: "06" },
		{ label: "Jul", value: "07" },
		{ label: "Aug", value: "08" },
		{ label: "Sep", value: "09" },
		{ label: "Oct", value: "10" },
		{ label: "Nov", value: "11" },
		{ label: "Dec", value: "12" },
	];
	const Days = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

	const [yearList, setYearList] = useState([]);
	const [dayList, setDayList] = useState([]);
	const [isSectionVisited, setIsSectionVisited] = useState(false);

	const [showDob, setShowDob] = useState(true);
	const [showGender, setShowGender] = useState(false);
	const [showMarried, setShowMarried] = useState(false);
	const [showCredit, setShowCredit] = useState(false);
	const [showBundleQuestion, setShowBundleQuestion] = useState(false);

	useEffect(() => {
		const currYear = new Date().getFullYear();
		let tempYears = [];
		for (let i = currYear; i >= currYear - 115; i--) {
			tempYears.push({ label: i.toString(), value: i.toString() });
		}
		setYearList(tempYears);
		let tempDays = [];
		for (let j = 1; j <= 31; j++) {
			tempDays.push({ label: j.toString().length == 1 ? `0${j}` : j.toString(), value: j.toString().length == 1 ? `0${j}` : j.toString() });
		}
		setDayList(tempDays);
	}, []);

	useEffect(() => {
		const sectionFinished = sessionStorage.getItem("rrQuizPersonalSectionVisited");
		if (sectionFinished && sectionFinished == "true") {
			setIsSectionVisited(true);
		} else {
			if (!props.values.property.dobMonth || !props.values.property.dobDay || !props.values.property.dobYear) {
				setShowDob(true);
			} else if (!props.values.property.gender) {
				setShowDob(false);
				setShowGender(true);
			} else if (!props.values.property.maritalStatus) {
				setShowDob(false);
				setShowGender(false);
				setShowMarried(true);
			} else {
				setShowDob(false);
				setShowGender(false);
				setShowMarried(false);
				setShowCredit(true);
			}
		}
		window.scroll({ top: 0, left: 0, behavior: "smooth" });
	}, []);

	function onDobMonthChange(value) {
		setFieldValue("property.dobMonth", value);
		setFieldValue("drivers[0].dobMonth", value);
		let month = parseInt(value) - 1;
		let tempDays = [];
		for (let j = 1; j <= Days[month]; j++) {
			tempDays.push({ label: j.toString().length == 1 ? `0${j}` : j.toString(), value: j.toString().length == 1 ? `0${j}` : j.toString() });
		}
		setDayList(tempDays);

		if (props.values.property.dobDay && props.values.property.dobDay != "" && parseInt(props.values.property.dobDay) > Days[month]) {
			setFieldValue("property.dobDay", "01");
			setFieldValue("drivers[0].dobDay", value);
		}

		// Show next question if all 3 values have been filled
		if (value != "" && props.values.property.dobDay != "" && props.values.property.dobYear != "") {
			setTimeout(() => {
				setShowDob(false);
				setShowGender(true);
			}, 200);
		}
	}
	function onDobDayChange(value) {
		setFieldValue("property.dobDay", value);
		setFieldValue("drivers[0].dobDay", value);
		// Show next question if all 3 values have been filled
		if (props.values.property.dobMonth != "" && value != "" && props.values.property.dobYear != "") {
			setTimeout(() => {
				setShowDob(false);
				setShowGender(true);
			}, 200);
		}
	}
	function onDobYearChange(value) {
		setFieldValue("property.dobYear", value);
		setFieldValue("drivers[0].dobYear", value);
		// Show next question if all 3 values have been filled
		if (props.values.property.dobMonth != "" && props.values.property.dobDay != "" && value != "") {
			setTimeout(() => {
				setShowDob(false);
				setShowGender(true);
			}, 200);
		}
	}
	function onPersonalDobNext() {
		props.setTouched({
			property: {
				dobDay: true,
				dobMonth: true,
				dobYear: true,
			},
		});
		props.validateForm().then((errors) => {
			if (props.values.property.dobMonth != "" && props.values.property.dobDay != "" && props.values.property.dobYear != "") {
				setShowDob(false);
				setShowGender(true);
			} else {
				console.log(errors);
			}
		});
	}

	function onGenderChange(value) {
		setFieldValue("property.gender", value);
		setFieldValue("drivers[0].gender", value);
		setTimeout(() => {
			setShowGender(false);
			setShowMarried(true);
		}, 200);
	}
	function onPersonalGenderBack() {
		setShowGender(false);
		setShowDob(true);
	}
	function onPersonalGenderNext() {
		props.setTouched({
			property: {
				gender: true,
			},
		});
		props.validateForm().then((errors) => {
			if (props.values.property.gender != "") {
				setShowGender(false);
				setShowMarried(true);
			} else {
				console.log(errors);
			}
		});
	}

	function onMarriedChange(value) {
		setFieldValue("property.maritalStatus", value);
		setFieldValue("drivers[0].maritalStatus", value);
		setTimeout(() => {
			setShowMarried(false);
			setShowCredit(true);
		}, 200);
	}
	function onPersonalMarriedBack() {
		setShowMarried(false);
		setShowGender(true);
	}
	function onPersonalMarriedNext() {
		props.setTouched({
			property: {
				maritalStatus: true,
			},
		});
		props.validateForm().then((errors) => {
			if (props.values.property.maritalStatus != "") {
				setShowMarried(false);
				setShowCredit(true);
			} else {
				console.log(errors);
			}
		});
	}

	function onCreditScoreChange(value) {
		setFieldValue("property.creditScore", value);
		setFieldValue("creditScore", value);
		setTimeout(() => {
			setShowCredit(false);
			setShowBundleQuestion(true);
		}, 200);
	}
	function onPersonalCreditBack() {
		setShowCredit(false);
		setShowMarried(true);
	}
	function onPersonalCreditNext() {
		props.setTouched({
			property: {
				creditScore: true,
			},
		});
		props.validateForm().then((errors) => {
			if (props.values.property.creditScore != "") {
				setShowCredit(false);
				setShowBundleQuestion(true);
			} else {
				console.log(errors);
			}
		});
	}

	function onPersonalBundleBack() {
		setShowBundleQuestion(false);
		setShowCredit(true);
	}

	function personalContinueClick() {
		props.setTouched({
			bundleInsurance: true,
			property: {
				dobDay: true,
				dobMonth: true,
				dobYear: true,
				gender: true,
				maritalStatus: true,
				creditScore: true,
			},
		});
		props.validateForm().then((errors) => {
			if (Object.keys(errors).length === 0) {
				const newItems = [...props.steps];
				let currentStepIndex = newItems.findIndex((row) => row.key === "PERSONAL");
				let step = newItems[currentStepIndex];
				step.isVisited = "true";
				step.isDisabled = "false";
				newItems[currentStepIndex] = step;
				// Next step
				if (newItems[currentStepIndex + 1]) {
					step = newItems[currentStepIndex + 1];
					step.isDisabled = "false";
					newItems[currentStepIndex + 1] = step;
				}
				props.setSteps(newItems);
				props.setProgressPercentage(40);
				props.setIsPersonalSectionCompleted(true);
				sessionStorage.setItem("rrQuizPersonalSectionVisited", "true");
				goToNextStep("VEHICLE", true);
			} else {
				console.log(errors);
			}
		});
	}
	function getRates() {
		setFieldValue("queryType", type);
		props.setTouched({
			bundleInsurance: true,
			property: {
				dobDay: true,
				dobMonth: true,
				dobYear: true,
				gender: true,
				maritalStatus: true,
				creditScore: true,
				policyType: true,
				yearsOwned: true,
				squareFootage: true,
				constructionYear: true,
				roofLastUpgradedYear: true,
				dwellingAmount: true,
				personalPropertyAmount: true,
				personalLiabilityAmount: true,
				nofStories: true,
				constructionType: true,
				substructureType: true,
				roofType: true,
				isCurrentlyInsured: true,
				insuredForYears: true,
				claimFreeYears: true,
			},
		});
		props.validateForm().then((errors) => {
			props.setErrorSubmitting(false);
			if (Object.keys(errors).length === 0) {
				const newItems = [...props.steps];
				let currentStepIndex = newItems.findIndex((row) => row.key === "PERSONAL");
				let step = newItems[currentStepIndex];
				step.isVisited = "true";
				step.isDisabled = "false";
				newItems[currentStepIndex] = step;
				props.setSteps(newItems);

				props.setProgressPercentage(100);
				document.getElementById("finley-spinner-search") && document.getElementById("finley-spinner-search").classList.add("show");
				props.setIsSubmitInProgress(true);
				props.setIsPersonalSectionCompleted(true);
				sessionStorage.setItem("rrQuizPersonalSectionVisited", "true");
				props.submitForm();
			} else {
				console.log(errors);
			}
		});
	}

	return (
		<React.Fragment>
			{(isSectionVisited || showDob) && (
				<React.Fragment>
					<Label text="What's your date of birth?"></Label>
					<RowContainer>
						<Dropdown
							placeholder="MM"
							name="property.dobMonth"
							value="property.dobMonth"
							onChange={(value) => {
								onDobMonthChange(value);
							}}
							options={MonthList}
							marginRight="1rem"
						/>
						<Dropdown
							placeholder="DD"
							name="property.dobDay"
							value="property.dobDay"
							onChange={(value) => {
								onDobDayChange(value);
							}}
							options={dayList}
							marginRight="1rem"
						/>
						<Dropdown
							placeholder="YYYY"
							name="property.dobYear"
							value="property.dobYear"
							onChange={(value) => {
								onDobYearChange(value);
							}}
							options={yearList}
						/>
					</RowContainer>
					{props.touched &&
						props.touched.property &&
						props.errors &&
						props.errors.property &&
						((props.touched.property.dobDay && props.errors.property.dobDay) ||
							(props.touched.property.dobMonth && props.errors.property.dobMonth) ||
							(props.touched.property.dobYear && props.errors.property.dobYear)) && (
							<Error text={props.errors.property.dobDay || props.errors.property.dobMonth || props.errors.property.dobYear} />
						)}
					{!isSectionVisited && <Footer showBack={false} forwardClick={() => onPersonalDobNext()} />}
				</React.Fragment>
			)}

			{(isSectionVisited || showGender) && (
				<React.Fragment>
					<Label text="Sex as described on driver's license:"></Label>
					<Checkbox
						label="Male"
						checked={props.values.property.gender === "Male"}
						onClick={() => {
							onGenderChange("Male");
						}}
					/>
					<Checkbox
						label="Female"
						checked={props.values.property.gender === "Female"}
						onClick={() => {
							onGenderChange("Female");
						}}
					/>
					<Checkbox
						label="Non-binary"
						checked={props.values.property.gender === "X"}
						onClick={() => {
							onDriverGenderChange("X");
						}}
					/>
					{props.touched && props.touched.property && props.touched.property.gender && props.errors && props.errors.property && props.errors.property.gender && (
						<Error text={props.errors.property.gender} />
					)}
					<InfoText text="Some insurers consider gender when determining rates, but other factors usually have a bigger impact." />
					{!isSectionVisited && <Footer backClick={() => onPersonalGenderBack()} forwardClick={() => onPersonalGenderNext()} />}
				</React.Fragment>
			)}

			{(isSectionVisited || showMarried) && (
				<React.Fragment>
					<Label text="Are you married?"></Label>
					<RowContainer>
						<Checkbox
							label="Yes"
							checked={props.values.property.maritalStatus === "true"}
							onClick={() => {
								onMarriedChange("true");
							}}
							style={{ marginRight: "1rem", width: "100%" }}
						/>
						<Checkbox
							label="No"
							checked={props.values.property.maritalStatus === "false"}
							onClick={() => {
								onMarriedChange("false");
							}}
							style={{ width: "100%" }}
						/>
					</RowContainer>
					{props.touched && props.touched.property && props.touched.property.maritalStatus && props.errors && props.errors.property && props.errors.property.maritalStatus && (
						<Error text={props.errors.property.maritalStatus} />
					)}
					{!isSectionVisited && <Footer backClick={() => onPersonalMarriedBack()} forwardClick={() => onPersonalMarriedNext()} />}
				</React.Fragment>
			)}

			{(isSectionVisited || showCredit) && (
				<React.Fragment>
					<Label text="What is your credit score?"></Label>
					<Checkbox
						label="Excellent (800+)"
						checked={props.values.property.creditScore === "Excellent"}
						onClick={() => {
							onCreditScoreChange("Excellent");
						}}
					/>
					<Checkbox
						label="Very Good (740 - 799)"
						checked={props.values.property.creditScore === "Very Good"}
						onClick={() => {
							onCreditScoreChange("Very Good");
						}}
					/>
					<Checkbox
						label="Good (670 - 739)"
						checked={props.values.property.creditScore === "Good"}
						onClick={() => {
							onCreditScoreChange("Good");
						}}
					/>
					<Checkbox
						label="Fair (580 - 669)"
						checked={props.values.property.creditScore === "Fair"}
						onClick={() => {
							onCreditScoreChange("Fair");
						}}
					/>
					<Checkbox
						label="Poor (Below 580)"
						checked={props.values.property.creditScore === "Poor"}
						onClick={() => {
							onCreditScoreChange("Poor");
						}}
					/>
					{props.touched && props.touched.property && props.touched.property.creditScore && props.errors && props.errors.property && props.errors.property.creditScore && (
						<Error text={props.errors.property.creditScore} />
					)}
					{!isSectionVisited && <Footer backClick={() => onPersonalCreditBack()} forwardClick={() => onPersonalCreditNext()} />}
				</React.Fragment>
			)}

			{(isSectionVisited || showBundleQuestion) && (
				<React.Fragment>
					<Label text="Do you want to bundle and add auto insurance now?"></Label>
					<RowContainer>
						<Checkbox
							label="Yes"
							checked={props.values.bundleInsurance === "true"}
							onClick={() => {
								setFieldValue("bundleInsurance", "true");
							}}
							style={{ marginRight: "1rem", width: "100%" }}
						/>
						<Checkbox
							label="No"
							checked={props.values.bundleInsurance === "false"}
							onClick={() => {
								setFieldValue("bundleInsurance", "false");
							}}
							style={{ width: "100%" }}
						/>
					</RowContainer>
					{props.touched && props.touched.bundleInsurance && props.errors && props.errors.bundleInsurance && <Error text={props.errors.bundleInsurance} />}

					{props.values.bundleInsurance === "true" && (
						<RowContainer style={{ justifyContent: "center", marginTop: "2rem", alignItems: "baseline" }}>
							{!isSectionVisited && (
								<Link>
									<div style={{ marginRight: "1rem" }} className="light-link" onClick={() => onPersonalBundleBack()}>
										Previous
									</div>
								</Link>
							)}
							<Button onClick={personalContinueClick} text="Next step" />
						</RowContainer>
					)}
					{props.values.bundleInsurance === "false" && (
						<>
							<RowContainer style={{ justifyContent: "center", marginTop: "2rem", alignItems: "baseline" }}>
								{!isSectionVisited && (
									<Link>
										<div style={{ marginRight: "1rem" }} className="light-link" onClick={() => onPersonalBundleBack()}>
											Previous
										</div>
									</Link>
								)}
								<Button onClick={getRates} text="Get My Rates" isLoading={isSubmitInProgress} />
							</RowContainer>
							{props.errorSubmitting && <Error text="A few required fields are missing" />}
						</>						
					)}					
				</React.Fragment>
			)}
		</React.Fragment>
	);
}

export default Personal;
